import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { test } from "utils/helpers";
import "./Button.scss";
import * as googleAnalytics from "store/actions/googleAnalytics";
import hotkeys from "hotkeys-js";
import { getShortcutKeys, keyShortcutsLog } from "utils/keyboardShortcuts";
import { useMobileDimension } from "utils/hooks";
import { t } from "i18next";

const InviteToCallButton = (props) => {
  const onClick = props.onClick || null;
  const textClick = props.textClick || false;
  const dispatch = useDispatch();
  const [isMobileDimension] = useMobileDimension();
  useEffect(() => {
    hotkeys.filter = function () {
      return true;
    };
    hotkeys(getShortcutKeys().TOOGLE_INVITE_PANEL, (e, handler) => {
      e.preventDefault();
      onClick();
      keyShortcutsLog(`Key pressed - ${handler.key}`);
      dispatch(googleAnalytics.keyboardShortcuts("TOGGLE_INVITE_PANEL"));
    });
    return () => {
      hotkeys.unbind(getShortcutKeys().TOOGLE_INVITE_PANEL);
    };
  }, [dispatch, onClick]);

  return (
    <div className="toogle-button-container">
      <button
        aria-label={props["aria-label"]}
        className="invite-to-call-button"
        {...test("INVITE_TO_CALL")}
        onClick={onClick}
      ></button>
      {props.label && isMobileDimension && (
        <span onClick={onClick}>{props.label}</span>
      )}
      {!isMobileDimension && textClick && (
        <span onClick={onClick} className="toogle-button-label">
          {t("INVITE")}
        </span>
      )}
      {!isMobileDimension && !textClick && (
        <span className="toogle-button-label">{t("INVITE")}</span>
      )}
    </div>
  );
};

export default InviteToCallButton;
